<template>
  <TaskTitleForList :task="task" :readonly="readonly" :value="value" :show-label="showLabel" />
</template>

<script setup>
import TaskTitleForList from '../TaskTitleForList.vue'

defineProps({
  task: {
    type: Object,
    default: null,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [String, Object],
    default: null,
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
})
</script>
